<script setup lang="ts">
import { SELECTABLE_TRACKING_SERVICE } from '@/services/consts/operation_office';
import { computed } from 'vue';
import i18n from '@/lang/i18n';

const emit = defineEmits(['update:modelValue'])

const props = defineProps<{
  modelValue: string,
  isManagementOffice: boolean,
  windowInnerWidth: number,
}>();

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value)
  }
})
</script>
<template>
  <v-row class="text-form pl-4 pr-3 mb-3" v-if="isManagementOffice">
    <v-col :cols="windowInnerWidth > 800 ? 2 : 3">
      <h6 class="pl-4">
        {{ i18n.global.t('pages.operationOffices.form.trackingService') }}
      </h6>
    </v-col>
    <v-col cols="4">
      <v-select
        :items="SELECTABLE_TRACKING_SERVICE"
        v-model="modelValue"
      />
    </v-col>
  </v-row>
</template>
